<template>
  <div class="mask" v-show="dialogVisibled">
    <el-dialog
      :visible.sync="dialogVisibled"
      :modal-append-to-body="false"
      :close-on-press-escape="false"
      :modal="false"
      custom-class="dialog"
      :center="true"
      width="32rem"
    >
      <div class="txt">确定导出{{ id.length }}条数据？</div>
      <!--      <div class="input-box" v-else>-->
      <!--        <span class="name">导出条数：</span>-->
      <!--        <div class="input">-->
      <!--          <el-input v-model="num" placeholder="请输入" clearable/>-->
      <!--        </div>-->
      <!--      </div>-->
      <span slot="footer" class="dialog-footer">
        <el-button
          size="98"
          class="sub-color"
          @click="exportExcel"
          v-html="'确定'"
        />
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'Export',
  props: {
    funcName: {
      type: String
    },
    id: {
      type: Array,
      default: () => []
    },
    excelName: {
      type: String,
      default: 'excel'
    },
    state: {
      type: String
    }
  },
  data() {
    return {
      dialogVisibled: false,
      num: ''
    }
  },
  methods: {
    /**
     * 导出excel表
     */
    exportExcel() {
      const routeName = this.$route.name
      let data = {
        id_array: this.id
          .map(v => {
            return v.recordId || v.id || v.orderId
          })
          .join(','),
        pageSize: this.num
      }
      if (
        [
          'inSalesGoods',
          'forSalesGoods',
          'inStockGoods',
          'violatingGoods'
        ].includes(routeName)
      ) {
        data.search_type = this.state
      }
      this.api[this.funcName](data).then(res => {
        const blob = new Blob([res], {
          type: 'application/vnd.ms-excel'
        })
        let downloadElement = document.createElement('a')
        let href = window.URL.createObjectURL(blob) //建立下载的连接
        downloadElement.href = href
        downloadElement.download = `${this.excelName}.xlsx` //下载后文件名
        document.body.appendChild(downloadElement)
        downloadElement.click() //点击下载
        document.body.removeChild(downloadElement) //下载完成移除元素
        window.URL.revokeObjectURL(href) //释放掉blob对象
        this.dialogVisibled = false
      })
    },
    /**
     * 改变状态
     * @private
     */
    _openPop() {
      this.dialogVisibled = !this.dialogVisibled
    }
  }
}
</script>
